module.exports = __webpack_public_path__ + "ec2ac1b263053eb894fac7ee2ac2c91b.png";